import React from "react";
import { Pagination } from "react-bootstrap";
import { MdOutlineKeyboardDoubleArrowLeft, MdOutlineKeyboardDoubleArrowRight, MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight } from 'react-icons/md';
// import { GrCaretPrevious, GrCaretNext } from 'react-icons/gr';

import './paginationcmp.css';

const PaginationCmp = ({ totalPage, currentPage, getData }) => {
    return (
        <>
            <div className="last-one d-flex align-items-center justify-content-between mt-3">
                <div className="pagination_main">
                    {
                        (totalPage > 1) &&
                        <Pagination className="align-items-center mb-0">
                            <Pagination.First onClick={() => getData(1)} disabled={currentPage === 1 ? true : false} >
                                <MdOutlineKeyboardDoubleArrowLeft />
                            </Pagination.First>
                            <Pagination.Prev onClick={() => getData(currentPage - 1)} disabled={currentPage === 1 ? true : false}>
                                <MdOutlineKeyboardArrowLeft />
                            </Pagination.Prev>
                            {
                                (currentPage > 2) && (totalPage !== 3) &&
                                <Pagination.Ellipsis onClick={() => getData(currentPage - 2)} />
                            }
                            {
                                (currentPage === totalPage) && (totalPage > 2) &&
                                <Pagination.Item
                                    active={currentPage === (currentPage - 2)}
                                    onClick={() => getData(currentPage - 2)}
                                >
                                    {currentPage - 2}
                                </Pagination.Item>
                            }
                            {
                                (currentPage !== 1) &&
                                <Pagination.Item
                                    active={currentPage === (currentPage - 1)}
                                    onClick={() => getData(currentPage - 1)}
                                >
                                    {currentPage - 1}
                                </Pagination.Item>
                            }
                            <Pagination.Item
                                active={currentPage === currentPage}
                                onClick={() => getData(currentPage)}
                            >
                                {currentPage}
                            </Pagination.Item>
                            {
                                (currentPage !== totalPage) &&
                                <Pagination.Item
                                    active={currentPage === (currentPage + 1)}
                                    onClick={() => getData(currentPage + 1)}
                                >
                                    {currentPage + 1}
                                </Pagination.Item>
                            }
                            {
                                (currentPage === 1) && (totalPage > (currentPage + 1)) &&
                                <Pagination.Item
                                    active={currentPage === (currentPage + 2)}
                                    onClick={() => getData(currentPage + 2)}
                                >
                                    {currentPage + 2}
                                </Pagination.Item>
                            }
                            {
                                (totalPage > (currentPage + 1)) && (totalPage !== 3) &&
                                <Pagination.Ellipsis onClick={() => getData(currentPage + 2)} />
                            }
                            <Pagination.Next onClick={() => getData(currentPage + 1)} disabled={currentPage === totalPage ? true : false}>
                                <MdOutlineKeyboardArrowRight />
                            </Pagination.Next>
                            <Pagination.Last onClick={() => getData(totalPage)} disabled={currentPage === totalPage ? true : false}>
                                <MdOutlineKeyboardDoubleArrowRight />
                            </Pagination.Last>
                        </Pagination>
                    }
                </div>
            </div>
        </>
    );
};

export default PaginationCmp;
